import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@lib/stores";
import { ContentActions } from "@lib/stores/content/slices";
import { db } from "@modules/local/db";
import { useAppLiveQuery } from "@modules/local/hooks";

export function useWithContent(id: string | null | undefined) {
  const dispatch = useAppDispatch();

  const isLoading =
    useAppSelector(({ content }) => content.status) === "loading";

  const { result: content } = useAppLiveQuery(
    () => db.entities.get(id ?? ""),
    [id]
  );

  // const content2 = useAppSelector((state) =>
  //   state.content.data.find((d) => d.id === id)
  // );

  useEffect(() => {
    // TODO: check if we need to change this
    if (!id) return;

    if (content && content.id === id) return;

    dispatch(ContentActions.getContentEntityByIdAsync(id));
  }, [id, content?.id]);

  return { content: content?.id === id ? content : undefined, isLoading };
}
